module.exports = __webpack_public_path__ + "static/media/ma-jhumra-nach-nachchu-cover.a8a7e411.png";